module.exports = __webpack_public_path__ + "img/social-criteria.0758c0e9.png";